// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root_SYZJy{--rootPadding:0px}@media only screen and (min-width:768px){.root_SYZJy{--rootPadding:0px 0px 15px}}.root_SYZJy{margin:0 auto;max-width:900px;padding:var(--rootPadding)}.benefit_8x6f8:not(:last-child){margin-bottom:20px}.title_1W6jO{margin-bottom:10px;font-weight:600;font-size:16px;line-height:22px}.benefit_8x6f8 ul{list-style:disc}.benefit_8x6f8 li{margin-left:15px;margin-bottom:10px}.benefit_8x6f8 h3{margin-bottom:10px;font-weight:600;font-size:16px;line-height:22px}", ""]);
// Exports
exports.locals = {
	"root": "root_SYZJy",
	"benefit": "benefit_8x6f8",
	"title": "title_1W6jO"
};
module.exports = exports;
